import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./Header.module.css";
import logo from "../../assets/logo.png";
import { useContext } from "react";
import Swal from "sweetalert2";
import { AuthContext } from "../../context/AuthContext";


export default function Header() {
  const navigate = useNavigate();
  const { dispatch } = useContext(AuthContext);

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });

    Swal.fire({
      icon: "success",
      title: "로그아웃 완료",
      text: "다시 로그인해 주세요.",
    }).then(() => {
      navigate("/login", { replace: true });
    });
  };

  return (
    <header className={styles.header}>
      <div className={styles.brand} onClick={() => navigate("/dashboard")}>
        <img src={logo} alt="일상돌봄플랫폼 관리자 페이지 로고" className={styles.logo} />
        <span className={styles.title}>일상돌봄플랫폼 관리자 페이지</span>
      </div>

      <button
        type="button"
        className={styles.logoutBtn}
        onClick={handleLogout}
      >
        로그아웃
      </button>
    </header>
  );
}